import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';

import style from './delete-filterview-modal.module.less';
import { messages } from './messages';

export const DeleteFilterViewModal = ({ closeModal, filterViewToDelete, deleteFilterViewRequest }) => {
  const { displayName } = filterViewToDelete;
  const deleteFilterView = useCallback(() => {
    deleteFilterViewRequest(filterViewToDelete);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Modal className={style['delete-filterview-modal']}>
      <ModalHeader closeModal={closeModal}>
        <FormattedMessage {...messages.deleteViewModalHeader} />
      </ModalHeader>
      <ModalBody className={style['modal-body']}>
        <div className={style['modal-text']}>
          <FormattedMessage {...messages.deleteViewConfirmationMessage} values={{ viewName: <b>{displayName}</b> }} />
        </div>
      </ModalBody>
      <ModalFooter className={style['modal-footer']}>
        <Button className={style['cancel-button']} onClick={closeModal} theme='tertiary'>
          <FormattedMessage {...messages.cancelButtonText} />
        </Button>
        <Button onClick={deleteFilterView} theme='primary'>
          <FormattedMessage {...messages.deleteButtonText} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

DeleteFilterViewModal.propTypes = {
  deleteFilterViewRequest: PropTypes.func.isRequired,
  filterViewToDelete: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
};
